/* istanbul ignore file */

export { LinkPreview as default } from "./LinkPreview";
